import { render, staticRenderFns } from "./data_gizi.vue?vue&type=template&id=613208a0&"
import script from "./data_gizi.vue?vue&type=script&lang=js&"
export * from "./data_gizi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports